import { graphql, readInlineData } from "react-relay";

import {
  checkCanShowInPlusPlatform,
  checkIsPlusArticle,
} from "~/components/article/article-render/plus/helpers";
import { section } from "~/data";
import { pathname as SectionPathname } from "~/pages/section/index";
import type { helpersGetTypeNameNode$key } from "~/queries/__generated__/helpersGetTypeNameNode.graphql";

// This is to avoid missing query parameters from a base link for the app bar when redirecting with client route push, e.g. appBarVariant."
export const shouldRedirectBaseDynamicSectionLink = (
  pathName: string,
  query?: Record<string, string | undefined>,
) => {
  if (query?.appBarVariant) return false;
  return pathName === SectionPathname;
};

type GetIsSubSectionParameters = {
  entityId: string;
  parentSection: Nullish<string>;
};

export const getIsSubSection = ({ entityId, parentSection }: GetIsSubSectionParameters) => {
  const entityIdsOfSubSectionWithoutParentSection: string[] = [section.announcements.entityId];
  const parentSectionUuidsOfSection: string[] = [
    section.magazine.entityUuid,
    section.news.entityUuid,
    section.posties.read.entityUuid,
  ];

  return (
    entityIdsOfSubSectionWithoutParentSection.includes(entityId) ||
    (parentSection && !parentSectionUuidsOfSection.includes(parentSection))
  );
};

type GetTypeNameParameters = {
  query: Record<string, unknown>;
  reference: helpersGetTypeNameNode$key;
};

export const getTypeName = ({ query, reference }: GetTypeNameParameters) => {
  const content = readInlineData(
    graphql`
      fragment helpersGetTypeNameNode on BaseWithApplicationAndUrlAlias @inline {
        __typename
        entityId
        ... on Section {
          parentSection
        }
        ... on Topic {
          topicTypes: types
        }
        ...helpersCheckCanShowInPlusPlatformArticle
        ...helpersCheckIsPlusArticle
      }
    `,
    reference,
  );

  const { __typename, entityId, parentSection, topicTypes } = content;

  const isSubSection = getIsSubSection({
    entityId,
    parentSection,
  });

  if (topicTypes?.includes("news_agenda")) {
    return "NewsAgenda";
  } else if (__typename === "Section" && isSubSection) {
    return "SubSection";
  } else if (
    __typename === "Article" &&
    (checkIsPlusArticle(content) ||
      (checkCanShowInPlusPlatform(content) && query.display === "plus"))
  )
    return "Plus";
  return __typename;
};
